// AuthSign.js
import React, { useContext } from 'react';
import toast from 'react-hot-toast';
import CryptoJS from 'crypto-js';


const AuthSign = async (values, history, setIsLoggedIn, setUsername, setUserId, setPermissionsAccess, apiGlobal) => {
  const { username, passwords } = values;


  const loginData = new URLSearchParams({
    email: username,
    password: passwords,
  }).toString();

  try {
  //  const response = await fetch(`https://navrang.mvd-tech.io/API/login_api.php?${loginData}`, {
  //       method: 'GET',
  //       headers: {
  //         'Content-Type': 'application/json',
  //       },
  //     });
   const response = await fetch(`${apiGlobal}login_api.php?${loginData}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });

    const result = await response.json();
    // console.log(result);
    if (result.message === 'Success' && result.status) {
 localStorage.clear();

      if (result.token) {
        localStorage.setItem('authToken', result.token);
        console.log('Login successful! Token saved.');
        toast.success('Login successful!');
        setIsLoggedIn(true);
        setUsername(result?.user_name);
        setUserId(result?.user_id);
        setPermissionsAccess(result?.permission || {});


                        // Encrypt the permission
       const permissionsString = JSON.stringify(result?.permission);
       const encryptedPermissions = CryptoJS.AES
       .encrypt(permissionsString, 'T4$Bv9#Aa@QWz8m&5!Lpo1kHsTz4jL2').toString();
       localStorage.setItem('permissions', encryptedPermissions);


          // Encrypt the user_name
const encryptedUserName = CryptoJS
.AES.encrypt(result.user_name.toString(), 'T4$Bv9#Aa@QWz8m&5!Lpo1kHsTz4jL2').toString();
localStorage.setItem('userName', encryptedUserName);
        

        // Encrypt the user_id
const encryptedUserId = CryptoJS.AES.encrypt(result.user_id.toString(), 'T4$Bv9#Aa@QWz8m&5!Lpo1kHsTz4jL2').toString();

// Store the encrypted user_id in localStorage
localStorage.setItem('userid', encryptedUserId);
        setTimeout(() => {
          history.push('/app_dashboard'); 
        }, 2000);
      } else {
        toast.error('User Not Found');
        setIsLoggedIn(false);
        // console.error('No token received.');
      }
    } else {
      toast.error('User Not Authenticated');
    }
  } catch (error) {
    toast.error('Error during login:', error);
  }
};

export default AuthSign;

